export default __webpack_public_path__ + "static/media/IMG_1855.9274a7de.jpg";